<template>
  <div>
    <van-nav-bar title="加油站" left-text="返回" left-arrow @click-left="onClickLeft"/>
    <van-notice-bar left-icon="volume-o">
      <van-swipe vertical class="notice-swipe" :autoplay="3000" :show-indicators="false">
        <van-swipe-item>中石油加油站已经上线千里马，欢迎司机朋友们光临使用！</van-swipe-item>
      </van-swipe>
    </van-notice-bar>
    <!--<van-search v-model="boxno" show-action label="箱号" placeholder="请输入搜索箱号" @search="onSearch"></van-search>-->
    <div v-for="(item, index) in orderData" :key="index" @click="goSite(item)">
      <van-cell is-link title-style="flex: 5;font-size: 0.45rem;" icon="location-o" value="导航" :label="item.address">
        <!-- 使用 title 插槽来自定义标题 -->
        <template #title>
          <span>{{ item.site_name }}</span>
          <van-tag type="primary">营业</van-tag>
          <van-tag type="success">{{ item.oil_type }}</van-tag>
          <!--<van-tag type="danger">休息</van-tag>-->
        </template>
        <template #label>
          <span class="custom-label">{{ item.address }}</span><br/>
          <span class="custom-label">{{ item.tel }} {{ item.open_time }}</span>
        </template>
      </van-cell>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {Dialog, Search, List, NoticeBar} from 'vant';

Vue.use(NoticeBar);
Vue.use(Dialog);
Vue.use(Search);
Vue.use(List);

import {Cell, CellGroup} from 'vant';

Vue.use(Cell);
Vue.use(CellGroup);

export default {
  data() {
    return {
      orderData: [],
    };
  },
  methods: {
    onClickLeft() {
      this.$router.push({path: "/"});
    },
    //获取列表
    getList() {
      let querystring = require('querystring');
      this.$api.post('wx/site/list',
          querystring.stringify({
            tel: localStorage.getItem("tel"),
          })
      ).then(data => {
        if (data.data.status == 1) {
          this.orderData = data.data.data;
        } else {
          Dialog.alert({
            message: data.data.msg,
          }).then(() => {

          });
        }
      }).catch(err => {
        console.log(err);
      })
    },
    goSite(item) {
      location.href="https://api.map.baidu.com/marker?location="+item.lat_lng+"&title="+item.site_name+"&content="+item.address+"&zoom=10&output=html&src=webapp.baidu.openAPIdemo"
    },
    getCity() {
      const geoLocation = new BMap.Geolocation();
      geoLocation.getCurrentPosition(function(r){
        if(this.getStatus() == BMAP_STATUS_SUCCESS){
          var mk = new BMap.Marker(r.point);
          //alert('您的位置：'+r.point.lng+','+r.point.lat);
        }
        else {
          alert('failed'+this.getStatus());
        }
      });
    }
  },
  mounted() {
    this.getList();
    this.getCity();
  }
}
</script>

<style scoped>
.custom-label {
  font-size: .35rem;
  color: #0a0a0a;
}
</style>


// WEBPACK FOOTER //
// src/components/siteList.vue